import Vue from 'vue'
import Router from 'vue-router'
import WechatAuth from '@/plugin/wechatauth'
import WechatConfig from '@/config/WechatConfig'
import { env } from '@/config/env'
const Index = () => import('@/pages/Index/Index')
const Register = () => import('@/pages/Register/Register_Test')
const RegisterBirth = () => import('@/pages/Register/Register_Birth')
const Home = () => import('@/pages/Home/Home')
// 卡卷中心
const CardCenter = () => import('@/pages/CardCenter/CardCenter')

// 卡卷中心未使用的券
const UnusedCard = () => import('@/pages/CardCenter/components/unusedCard')

// 卡卷中心已使用的券
const UsedCard = () => import('@/pages/CardCenter/components/usedCard')

// 卡卷中心已过期的券
const OverDueCard = () => import('@/pages/CardCenter/components/overDueCard')

// 卡卷中心 => 已失效卡券
const CardCenterInvalid = () => import('@/pages/CardCenter/components/CardCenterInvalid')

// 个人中心
const PersonalCenter = () => import('@/pages/PersonalCenter/PersonalCenter')

// 个人账单
const PersonalBill = () => import('@/pages/PersonalBill/PersonalBill')
const Cash = () => import('@/pages/PersonalBill/components/Cash')
const Card = () => import('@/pages/PersonalBill/components/Card')
const Water = () => import('@/pages/PersonalBill/components/Water')

// 陈列活动
const DisplayActions = () => import('@/pages/DisplayAction/DisplayActions')

// 赠品签收
const GiftReceipt = () => import('@/pages/GiftReceipt/GiftReceipt')
const Gifts = () => import('@/pages/GiftReceipt/component/Gifts.vue')
const Agreement = () => import('@/pages/GiftReceipt/component/Agreement.vue')

// 奖励详情
const RewardDetail = () => import('@/pages/RewardDetail/RewardDetail')

// 电子协议
// const ElecProtocols = () => import('@/pages/ElecProtocols/ElecProtocols')

// 没有登录时的页面
const NotLogin = () => import('@/pages/notLogin/notLogin')
const Maintain = () => import('@/pages/404/index')

// 合同
const ElecProtocols = () => import('@/pages/contract/Contract')
const ContractDetail = () => import('@/pages/contract/ContractDetail')

const SearchRequestDataBase = () => import('@/pages/searchRequestDataBase/SearchRequestDataBase')

// 配送评分
const DealerGradeAction = () => import('@/pages/dealerGradeAction/DealerGradeAction')
// 业代评分
const SalesGradeAction = () => import('@/pages/salesGradeAction/SalesGradeAction')
// 评分列表
const dealerGrade = () => import('@/pages/gradeList/dealerGradeList')
// 评分列表
const salesGrade = () => import('@/pages/gradeList/salesGradeList')
// 业代待评价
const salesNotEvaluate = () => import('@/pages/gradeList/salesNotEvaluate/salesNotEvaluate')
// 业代已评价
const salesEvaluate = () => import('@/pages/gradeList/salesEvaluate/salesEvaluate')
// 配送商待评价
const dearNotEvaluate = () => import('@/pages/gradeList/dearNotEvaluate/dearNotEvaluate')
// 配送商已评价
const dealerEvaluate = () => import("@/pages/gradeList/dealerEvaluate/dealerEvaluate")

Vue.use(Router)

let base

switch (process.env.NODE_ENV) {
  case 'dev':
    base = ''
    break
  case 'sit':
    base = '/sit'
    break
  default:
    base = ''
}

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/searchRequestDataBase',
      component: SearchRequestDataBase
    },
    {
      path: '/contractDetail',
      component: ContractDetail
    },
    {
      path: '/notlogin',
      name: '华润怡宝',
      component: NotLogin
    },
    {
      path: '/maintain',
      name: '维护',
      component: Maintain
    },
    {
      path: '/register',
      name: '绑定',
      component: Register
    },
    {
      path: '/register_birth',
      name: '绑定',
      component: RegisterBirth
    },
    {
      path: base + '/customer-wechat/index.html',
      name: 'cpm-customer-wechat1',
      component: Index
    },
    {
      path: '/',
      name: 'cpm-customer-wechat2',
      component: Index
    },
    {
      path: '/index',
      name: 'cpm-customer-wechat3',
      component: Index,
      children: [{
        path: '/',
        name: '首页',
        component: Home
      },
      {
        path: '/home',
        name: '首页',
        component: Home
      },
      {
        path: '/cardCenter',
        name: '代金券中心',
        component: CardCenter,

        children: [{
          path: '/unusedCard',
          name: '',
          component: UnusedCard
        },
        {
          path: '/usedCard',
          name: '',
          component: UsedCard
        },
        {
          path: '/overDueCard',
          name: '',
          component: OverDueCard
        },
        {
          path: '/',
          name: '',
          component: UnusedCard
        }]
      },
      {
        path: '/cardCenterInvalid',
        name: '',
        component: CardCenterInvalid
      },
      {
        path: '/personalCenter',
        name: '个人中心',
        component: PersonalCenter
      },
      {
        path: '/GiftReceipt',
        name: '签收中心',
        component: GiftReceipt,
        children: [{
          path: '/gifts',
          component: Gifts
        }, {
          path: '/agreement',
          name: '待签协议',
          component: Agreement
        }, {
          path: '/',
          name: '',
          component: Gifts
        }]
      },
      {
        path: '/displayActions',
        name: '陈列活动',
        component: DisplayActions
      },
      {
        path: '/PersonalBill',
        name: '个人账单',
        component: PersonalBill,
        children: [{
          path: '/cash',
          component: Cash
        }, {
          path: '/card',
          component: Card
        }, {
          path: '/water',
          component: Water
        }, {
          path: '/',
          component: Cash
        }]
      },
      {
        path: '/RewardDetail',
        name: '奖励详情',
        component: RewardDetail
      },
      {
        path: '/ElecProtocols',
        name: '协议签署',
        component: ElecProtocols
      },
      {
        path: '/dealerGradeAction',
        name: '配送评分',
        component: DealerGradeAction
      },
      {
        path: '/salesGradeAction',
        name: '业代评分',
        component: SalesGradeAction
      },
      {
        path: '/dealerGrade',
        name: '评分页面',
        component: dealerGrade,
        children: [
          {
            path: '/dearNotEvaluate',
            name: '配送商待评价',
            component: dearNotEvaluate
          },
          {
            path: '/dealerEvaluate',
            name: '配送商已评价',
            component: dealerEvaluate
          }
        ]
      },
      {
        path: '/salesGrade',
        name: '评分页面',
        component: salesGrade,
        children: [
          {
            path: '/salesNotEvaluate',
            name: '业代待评价',
            component: salesNotEvaluate
          },
          {
            path: '/salesEvaluate',
            name: '业代已评价',
            component: salesEvaluate
          }
        ]
      }]
    }
  ]
})

// 微信授权插件初始化
if (env !== '') {
  Vue.use(WechatAuth, WechatConfig(router))
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js